// TODO: Load this asynchronously
import { fetchSafeJson } from './utils.js';
// import-attributes (`with { type: 'json' }`) break on some browsers, so use
// the shared fetch-based loader that wobble_flags.js uses.
export const SPRITE_RARITY = await fetchSafeJson('../data/sprite_distributions/wand_sprite_rates.json');

export const GUN_NAMES = [
  'Deadly','Rusty','Old','New','Shiny','Lethal','Dangerous','Large','Enormous','Tiny','Small','Big','Pretty','Terrifying','Confusing',
  'Mystery','Superior','Inferior','Destructive','Chaotic','Lawful','Good','Bad','Neutral','Worn','Polished','Waxen','Strong','Weak',
  'Complex','Tactical','Horrifying','Scary','Scratched','Untested','Prototype','Type a','Type b','Type x','Secret','Special','Unique',
  'Mega','Super','Giga','Turbo','Hyper','Alpha','Omega','Extreme','Vanilla','Flavourful','Sturdy','Solid','Used','Unused','Grey','Gray',
  'Sepia','Secretly','Actual','Genuine','Powerful','Double','Triple','Stereo','Ancient','Antique','Rustic','Artisan','Slick','Slim',
  'Bulky','Heavy','Efficient','Fast','Quick','Rapid','Slow','Veteran','Agile','Bitcoin','Online'
];

export const GUN_PROBS = {
    normal: {
        deck_capacity: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 3, max: 10, mean: 6, sharpness: 2},
                { prob: 0.1, min: 2, max: 7, mean: 4, sharpness: 4, extra: (gun) => gun['prob_unshuffle'] += 0.8},
                { prob: 0.05, min: 1, max: 5, mean: 3, sharpness: 4, extra: (gun) => gun['prob_unshuffle'] += 0.8},
                { prob: 0.15, min: 5, max: 11, mean: 8, sharpness: 2},
                { prob: 0.12, min: 2, max: 20, mean: 8, sharpness: 4},
                { prob: 0.15, min: 3, max: 12, mean: 6, sharpness: 6, extra: (gun) => gun['prob_draw_many'] += 0.8},
                { prob: 1, min: 1, max: 20, mean: 6, sharpness: 0}
            ]
        },
        reload_time: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 5, max: 60, mean: 30, sharpness: 2},
                { prob: 0.5, min: 1, max: 100, mean: 40, sharpness: 2},
                { prob: 0.02, min: 1, max: 100, mean: 20, sharpness: 0},
                { prob: 0.35, min: 1, max: 240, mean: 40, sharpness: 0, extra: (gun) => gun['prob_unshuffle'] += 0.5}
            ]
        },
        fire_rate_wait: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 1, max: 30, mean: 5, sharpness: 2},
                { prob: 0.1, min: 1, max: 50, mean: 15, sharpness: 3},
                { prob: 0.1, min: -15, max: 15, mean: 0, sharpness: 3},
                { prob: 0.45, min: 0, max: 35, mean: 12, sharpness: 0}
            ]
        },
        spread_degrees: {
            totalProb: 0,
            probs: [
                { prob: 1, min: -5, max: 10, mean: 0, sharpness: 3},
                { prob: 0.1, min: -35, max: 35, mean: 0, sharpness: 0}
            ]
        },
        speed_multiplier: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 0.8, max: 1.2, mean: 1.0, sharpness: 6.0},
                { prob: 0.05, min: 1.0, max: 2, mean: 1.1, sharpness: 3.0},
                { prob: 0.05, min: 0.5, max: 1.0, mean: 0.9, sharpness: 3.0},
                { prob: 1, min: 0.8, max: 1.2, mean: 1.0, sharpness: 0},
                { prob: 0.001, min: 1.0, max: 10.0, mean: 5.0, sharpness: 2.0}
            ]
        },
        actions_per_round: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 1, max: 3, mean: 1, sharpness: 3},
                { prob: 0.2, min: 2, max: 4, mean: 2, sharpness: 8},
                { prob: 0.05, min: 1, max: 5, mean: 2, sharpness: 2},
                { prob: 1, min: 1, max: 5, mean: 2, sharpness: 0}
            ]
        }
    },
    better: {
        deck_capacity: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 5, max: 13, mean: 8, sharpness: 2}
            ]
        },
        reload_time: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 5, max: 40, mean: 20, sharpness: 2}
            ]
        },
        fire_rate_wait: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 1, max: 35, mean: 5, sharpness: 2}
            ]
        },
        spread_degrees: {
            totalProb: 0,
            probs: [
                { prob: 1, min: -1, max: 2, mean: 0, sharpness: 3}
            ]
        },
        speed_multiplier: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 0.8, max: 1.2, mean: 1.0, sharpness: 6.0}
            ]
        },
        actions_per_round: {
            totalProb: 0,
            probs: [
                { prob: 1, min: 1, max: 3, mean: 1, sharpness: 3}
            ]
        }
    }
};

export const WAND_TYPES = {
    'wand_level_01': {
        type: 'normal',
        cost: 30,
        level: 1,
        force_unshuffle: false,
    },
    'wand_level_01_better': {
        type: 'better',
        cost: 30,
        level: 1,
        force_unshuffle: false,
    },
    'wand_unshuffle_01': {
        type: 'normal',
        cost: 25,
        level: 1,
        force_unshuffle: true,
    },
    'wand_level_02': {
        type: 'normal',
        cost: 40,
        level: 2,
        force_unshuffle: false,
    },
    'wand_level_02_better': {
        type: 'better',
        cost: 40,
        level: 2,
        force_unshuffle: false,
    },
    'wand_unshuffle_02': {
        type: 'normal',
        cost: 40,
        level: 2,
        force_unshuffle: true,
    },
    'wand_level_03': {
        type: 'normal',
        cost: 60,
        level: 3,
        force_unshuffle: false,
    },
    'wand_level_03_better': {
        type: 'better',
        cost: 60,
        level: 3,
        force_unshuffle: false,
    },
    'wand_unshuffle_03': {
        type: 'normal',
        cost: 60,
        level: 3,
        force_unshuffle: true,
    },
    'wand_level_04': {
        type: 'normal',
        cost: 80,
        level: 4,
        force_unshuffle: false,
    },
    'wand_level_04_better': {
        type: 'better',
        cost: 80,
        level: 4,
        force_unshuffle: false,
    },
    'wand_unshuffle_04': {
        type: 'normal',
        cost: 80,
        level: 4,
        force_unshuffle: true,
    },
    'wand_level_05': {
        type: 'normal',
        cost: 100,
        level: 5,
        force_unshuffle: false,
    },
    'wand_level_05_better': {
        type: 'better',
        cost: 100,
        level: 5,
        force_unshuffle: false,
    },
    'wand_unshuffle_05': {
        type: 'normal',
        cost: 100,
        level: 5,
        force_unshuffle: true,
    },
    'wand_level_06': {
        type: 'normal',
        cost: 120,
        level: 6,
        force_unshuffle: false,
    },
    'wand_level_06_better': {
        type: 'better',
        cost: 120,
        level: 6,
        force_unshuffle: false,
    },
    'wand_unshuffle_06': {
        type: 'normal',
        cost: 120,
        level: 6,
        force_unshuffle: true,
    },
    'wand_level_10': {
        type: 'normal',
        cost: 200,
        level: 11,
        force_unshuffle: false,
    },
	'wand_unshuffle_10': {
        type: 'normal',
        cost: 180,
        level: 11,
        force_unshuffle: true,
    }
};

export const PREMADE_WANDS = [
    {
        premade_index: 1,
        name: 'Good Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 7,
        reload_time: 27,
        shuffle_deck_when_empty: 1,
        fire_rate_wait: 2,
        spread_degrees: 8,
        mana_max: 220,
        mana_charge_speed: 45,
        speed_multiplier: 1.03398,
        sprite: 'wand_0484',
		grip: {x:2,y:2},
		tip: {x:10,y:2}
    },
    {
        premade_index: 2,
        name: 'Good Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 5,
        reload_time: 25,
        shuffle_deck_when_empty: 1,
        fire_rate_wait: 2,
        spread_degrees: 2,
        mana_max: 250,
        mana_charge_speed: 53,
        speed_multiplier: 0.982264,
        sprite: 'wand_0654',
		grip: {x:1,y:2},
		tip: {x:10,y:2}
    },
    {
        premade_index: 3,
        name: 'Neutral Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 6,
        reload_time: 90,
        shuffle_deck_when_empty: 1,
        fire_rate_wait: 2,
        spread_degrees: -3,
        mana_max: 180,
        mana_charge_speed: 54,
        speed_multiplier: 0.994967,
        sprite: 'wand_0958',
		grip: {x:2,y:3},
		tip: {x:10,y:3}
    },
    {
        premade_index: 4,
        name: 'Antique Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 3,
        reload_time: 16,
        shuffle_deck_when_empty: 0,
        fire_rate_wait: 23,
        spread_degrees: -1,
        mana_max: 190,
        mana_charge_speed: 51,
        speed_multiplier: 0.934037,
        sprite: 'wand_0516',
		grip: {x:1,y:5},
		tip: {x:8,y:5}
    },
    {
        premade_index: 5,
        name: 'Slim Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 5,
        reload_time: 4,
        shuffle_deck_when_empty: 1,
        fire_rate_wait: 6,
        spread_degrees: 6,
        mana_max: 210,
        mana_charge_speed: 52,
        speed_multiplier: 0.824541,
        sprite: 'wand_0484',
		grip: {x:2,y:2},
		tip: {x:10,y:2}
    },
    {
        premade_index: 6,
        name: 'Superior Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 6,
        reload_time: 23,
        shuffle_deck_when_empty: 0,
        fire_rate_wait: 13,
        spread_degrees: 3,
        mana_max: 250,
        mana_charge_speed: 49,
        speed_multiplier: 0.985946,
        sprite: 'wand_0058',
		grip: {x:2,y:3},
		tip: {x:10,y:3}
    },
    {
        premade_index: 7,
        name: 'Shiny Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 3,
        reload_time: 40,
        shuffle_deck_when_empty: 0,
        fire_rate_wait: 26,
        spread_degrees: 1,
        mana_max: 170,
        mana_charge_speed: 55,
        speed_multiplier: 0.955205,
        sprite: 'wand_0120',
		grip: {x:1,y:8},
		tip: {x:8,y:8}
    },
    {
        premade_index: 8,
        name: 'Solid Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 7,
        reload_time: 26,
        shuffle_deck_when_empty: 1,
        fire_rate_wait: 10,
        spread_degrees: 2,
        mana_max: 160,
        mana_charge_speed: 52,
        speed_multiplier: 0.987743,
        sprite: 'wand_0898',
		grip: {x:2,y:2},
		tip: {x:10,y:2}
    },
    {
        premade_index: 9,
        name: 'Turbo Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 6,
        reload_time: 49,
        shuffle_deck_when_empty: 1,
        fire_rate_wait: 3,
        spread_degrees: 3,
        mana_max: 160,
        mana_charge_speed: 46,
        speed_multiplier: 0.853983,
        sprite: 'wand_0724',
		grip: {x:1,y:1},
		tip: {x:10,y:1}
    },
    {
        premade_index: 10,
        name: 'Large Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 3,
        reload_time: 26,
        shuffle_deck_when_empty: 0,
        fire_rate_wait: 3,
        spread_degrees: -1,
        mana_max: 210,
        mana_charge_speed: 46,
        speed_multiplier: 1.05598,
        sprite: 'wand_0326',
		grip: {x:1,y:3},
		tip: {x:8,y:3}
    },
    {
        premade_index: 11,
        name: 'Vanilla Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 2,
        reload_time: 26,
        shuffle_deck_when_empty: 0,
        fire_rate_wait: 20,
        spread_degrees: -2,
        mana_max: 250,
        mana_charge_speed: 50,
        speed_multiplier: 1.02408,
        sprite: 'wand_0374',
		grip: {x:1,y:3},
		tip: {x:8,y:3}
    },
    {
        premade_index: 12,
        name: 'Bad Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 6,
        reload_time: 50,
        shuffle_deck_when_empty: 0,
        fire_rate_wait: 14,
        spread_degrees: -2,
        mana_max: 250,
        mana_charge_speed: 49,
        speed_multiplier: 0.995504,
        sprite: 'wand_0324',
		grip: {x:1,y:4},
		tip: {x:10,y:4}
    },
    {
        premade_index: 13,
        name: 'Large Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 5,
        reload_time: 45,
        shuffle_deck_when_empty: 0,
        fire_rate_wait: 4,
        spread_degrees: 1,
        mana_max: 220,
        mana_charge_speed: 51,
        speed_multiplier: 0.969829,
        sprite: 'wand_0309',
		grip: {x:1,y:3},
		tip: {x:9,y:3}
    },
    {
        premade_index: 14,
        name: 'Slick Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 2,
        reload_time: 12,
        shuffle_deck_when_empty: 0,
        fire_rate_wait: 6,
        spread_degrees: 1,
        mana_max: 210,
        mana_charge_speed: 50,
        speed_multiplier: 0.988051,
        sprite: 'wand_0230',
		grip: {x:1,y:3},
		tip: {x:8,y:3}
    },
    {
        premade_index: 15,
        name: 'Bulky Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 11,
        reload_time: 53,
        shuffle_deck_when_empty: 1,
        fire_rate_wait: 24,
        spread_degrees: 1,
        mana_max: 170,
        mana_charge_speed: 49,
        speed_multiplier: 0.904531,
        sprite: 'wand_0063',
		grip: {x:1,y:5},
		tip: {x:14,y:5}
    },
    {
        premade_index: 16,
        name: 'Giga Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 9,
        reload_time: 18,
        shuffle_deck_when_empty: 1,
        fire_rate_wait: 26,
        spread_degrees: -3,
        mana_max: 750,
        mana_charge_speed: 10,
        speed_multiplier: 1.07678,
        sprite: 'wand_0830',
		grip: {x:2,y:5},
		tip: {x:12,y:5}
    },
    {
        premade_index: 17,
        name: 'Type a Rapid bolt',
        actions_per_round: 1,
        deck_capacity: 6,
        reload_time: 14,
        shuffle_deck_when_empty: 1,
        fire_rate_wait: 2,
        spread_degrees: 5,
        mana_max: 190,
        mana_charge_speed: 52,
        speed_multiplier: 0.987879,
        sprite: 'wand_1000',
		grip: {x:2,y:2},
		tip: {x:10,y:2}
    },
];

// index, grip_x, grip_y, tip_x, tip_y, fire_rate_wait, actions_per_round, shuffle_deck_when_empty, deck_capacity, spread_degrees, reload_time
export const WAND_SHAPES = [
	[0, 2, 5, 21, 5, 4, 1, 0, 5, 1, 1],
	[1, 2, 5, 19, 5, 3, 0, 1, 6, 0, 1],
	[2, 1, 6, 21, 6, 3, 1, 1, 7, 0, 0],
	[3, 2, 4, 13, 4, 3, 2, 0, 2, 0, 1],
	[4, 3, 4, 21, 4, 3, 2, 1, 6, 0, 1],
	[5, 1, 7, 19, 7, 4, 2, 0, 5, 0, 2],
	[6, 2, 3, 14, 3, 0, 1, 1, 4, 1, 2],
	[7, 1, 6, 8, 6, 3, 0, 0, 0, 0, 2],
	[8, 1, 6, 16, 6, 3, 1, 1, 5, 0, 1],
	[9, 2, 6, 20, 6, 3, 0, 0, 6, 1, 0],
	[10, 1, 4, 9, 4, 2, 2, 1, 0, 1, 2],
	[11, 1, 3, 12, 3, 1, 0, 0, 2, 1, 1],
	[12, 1, 6, 9, 6, 3, 1, 1, 1, 1, 1],
	[13, 1, 5, 9, 5, 3, 1, 0, 1, 2, 2],
	[14, 3, 3, 17, 3, 1, 0, 0, 5, 0, 0],
	[15, 2, 3, 14, 3, 0, 0, 0, 3, 1, 0],
	[16, 3, 6, 15, 6, 4, 2, 0, 3, 1, 0],
	[17, 1, 3, 8, 3, 1, 1, 1, 1, 2, 2],
	[18, 1, 5, 7, 5, 2, 1, 0, 0, 1, 0],
	[19, 2, 7, 14, 7, 4, 1, 0, 4, 0, 0],
	[20, 0, 5, 19, 5, 2, 1, 1, 4, 1, 1],
	[21, 1, 4, 16, 4, 0, 2, 1, 3, 1, 1],
	[22, 1, 4, 11, 4, 2, 2, 1, 1, 2, 1],
	[23, 1, 6, 7, 6, 3, 1, 0, 0, 1, 0],
	[24, 1, 4, 18, 4, 3, 2, 1, 5, 1, 1],
	[25, 1, 3, 15, 3, 0, 2, 0, 3, 1, 1],
	[26, 2, 3, 14, 3, 0, 0, 0, 3, 0, 2],
	[27, 3, 4, 24, 4, 1, 1, 1, 6, 2, 0],
	[28, 1, 7, 15, 7, 4, 2, 1, 3, 2, 2],
	[29, 1, 7, 19, 7, 4, 0, 0, 6, 1, 2],
	[30, 1, 3, 7, 3, 0, 1, 0, 0, 2, 2],
	[31, 2, 5, 20, 5, 4, 2, 1, 6, 1, 0],
	[32, 1, 7, 16, 7, 4, 1, 0, 5, 2, 2],
	[33, 1, 5, 17, 5, 4, 1, 0, 5, 2, 2],
	[34, 2, 3, 19, 3, 3, 1, 0, 6, 2, 0],
	[35, 2, 5, 22, 5, 2, 2, 0, 7, 1, 0],
	[36, 1, 3, 13, 3, 0, 2, 0, 2, 1, 0],
	[37, 2, 5, 13, 5, 3, 1, 0, 3, 0, 1],
	[38, 1, 6, 16, 6, 3, 1, 1, 2, 0, 0],
	[39, 3, 2, 15, 2, 0, 1, 1, 4, 0, 2],
	[40, 3, 3, 17, 3, 0, 0, 0, 5, 1, 1],
	[41, 4, 5, 21, 5, 4, 1, 1, 5, 2, 0],
	[42, 3, 7, 16, 7, 4, 2, 1, 3, 1, 1],
	[43, 3, 4, 16, 4, 2, 2, 1, 3, 1, 0],
	[44, 2, 8, 20, 8, 4, 0, 0, 6, 0, 1],
	[45, 1, 3, 9, 3, 1, 1, 0, 1, 1, 2],
	[46, 2, 3, 15, 3, 2, 2, 1, 3, 1, 1],
	[47, 1, 7, 12, 7, 4, 0, 0, 2, 2, 2],
	[48, 2, 4, 19, 4, 2, 1, 0, 6, 0, 1],
	[49, 2, 4, 20, 4, 2, 0, 1, 6, 2, 1],
	[50, 4, 7, 26, 7, 4, 1, 0, 7, 2, 0],
	[51, 3, 4, 20, 4, 2, 0, 1, 6, 0, 2],
	[52, 2, 6, 17, 6, 3, 0, 1, 5, 1, 1],
	[53, 1, 4, 9, 4, 2, 2, 1, 0, 2, 0],
	[54, 1, 3, 13, 3, 0, 2, 0, 2, 2, 0],
	[55, 2, 5, 22, 5, 3, 0, 1, 7, 0, 1],
	[56, 3, 3, 19, 3, 1, 1, 0, 6, 2, 2],
	[57, 1, 7, 14, 7, 4, 0, 0, 3, 2, 0],
	[58, 2, 3, 10, 3, 1, 0, 0, 1, 0, 0],
	[59, 2, 2, 12, 2, 1, 0, 1, 2, 1, 2],
	[60, 1, 5, 21, 5, 4, 0, 1, 7, 1, 2],
	[61, 2, 5, 21, 5, 3, 1, 0, 7, 0, 1],
	[62, 0, 8, 16, 8, 4, 0, 0, 4, 0, 2],
	[63, 1, 5, 14, 5, 3, 0, 1, 3, 0, 1],
	[64, 3, 4, 16, 4, 2, 1, 1, 5, 0, 2],
	[65, 2, 5, 18, 5, 3, 0, 1, 5, 1, 1],
	[66, 1, 5, 17, 5, 3, 2, 1, 4, 1, 2],
	[67, 1, 5, 11, 5, 3, 1, 1, 2, 0, 0],
	[68, 1, 3, 19, 3, 0, 1, 1, 6, 2, 0],
	[69, 2, 6, 23, 6, 4, 1, 1, 6, 2, 2],
	[70, 2, 3, 10, 3, 0, 0, 0, 1, 2, 2],
	[71, 1, 5, 7, 5, 3, 1, 0, 0, 0, 0],
	[72, 1, 3, 7, 3, 1, 1, 0, 0, 2, 2],
	[73, 1, 3, 14, 3, 1, 0, 0, 3, 1, 1],
	[74, 1, 7, 9, 7, 4, 1, 0, 1, 2, 2],
	[75, 1, 4, 8, 4, 3, 0, 0, 0, 1, 1],
	[76, 1, 3, 10, 3, 2, 0, 1, 1, 2, 2],
	[77, 1, 5, 8, 5, 4, 0, 0, 0, 2, 0],
	[78, 2, 4, 26, 4, 2, 1, 1, 7, 0, 2],
	[79, 1, 5, 24, 5, 4, 1, 1, 6, 2, 2],
	[80, 3, 4, 18, 4, 0, 2, 1, 4, 2, 2],
	[81, 1, 3, 14, 3, 1, 0, 1, 3, 2, 1],
	[82, 3, 5, 18, 5, 3, 2, 0, 5, 1, 2],
	[83, 1, 4, 23, 4, 1, 2, 1, 7, 1, 2],
	[84, 4, 3, 20, 3, 1, 0, 0, 6, 0, 0],
	[85, 3, 4, 16, 4, 2, 0, 1, 4, 0, 1],
	[86, 2, 5, 12, 5, 3, 0, 0, 2, 1, 0],
	[87, 2, 5, 12, 5, 3, 0, 0, 2, 2, 2],
	[88, 2, 4, 18, 4, 1, 1, 1, 3, 0, 2],
	[89, 4, 3, 21, 3, 0, 2, 1, 6, 0, 2],
	[90, 4, 7, 22, 7, 4, 0, 0, 7, 2, 2],
	[91, 1, 6, 14, 6, 4, 0, 1, 3, 1, 1],
	[92, 1, 3, 15, 3, 1, 2, 1, 3, 0, 1],
	[93, 1, 3, 11, 3, 0, 2, 0, 1, 1, 1],
	[94, 1, 4, 19, 4, 1, 1, 1, 4, 2, 2],
	[95, 1, 3, 7, 3, 0, 1, 0, 0, 2, 1],
	[96, 1, 7, 11, 7, 4, 1, 1, 2, 1, 0],
	[97, 3, 4, 19, 4, 2, 1, 1, 6, 0, 2],
	[98, 1, 5, 14, 5, 3, 0, 0, 3, 0, 2],
	[99, 2, 4, 13, 4, 2, 2, 1, 2, 2, 1],
	[100, 0, 3, 19, 3, 1, 0, 1, 6, 2, 0],
	[101, 1, 5, 14, 5, 4, 0, 0, 3, 2, 0],
	[102, 1, 7, 9, 7, 4, 1, 0, 1, 0, 0],
	[103, 4, 4, 22, 4, 1, 2, 0, 6, 2, 1],
	[104, 2, 5, 17, 5, 3, 0, 1, 5, 0, 0],
	[105, 1, 4, 8, 4, 2, 0, 1, 0, 2, 1],
	[106, 1, 5, 7, 5, 2, 1, 0, 0, 2, 0],
	[107, 1, 7, 19, 7, 4, 2, 1, 5, 1, 2],
	[108, 2, 3, 11, 3, 0, 2, 0, 1, 0, 1],
	[109, 1, 3, 10, 3, 2, 2, 0, 1, 0, 2],
	[110, 2, 2, 11, 2, 1, 1, 1, 2, 2, 2],
	[111, 3, 5, 18, 5, 2, 1, 0, 3, 2, 2],
	[112, 3, 5, 16, 5, 3, 0, 1, 4, 0, 2],
	[113, 1, 6, 9, 6, 3, 2, 1, 0, 1, 0],
	[114, 1, 3, 9, 3, 0, 1, 0, 1, 0, 2],
	[115, 0, 5, 17, 5, 3, 2, 1, 4, 0, 2],
	[116, 0, 3, 14, 3, 0, 1, 0, 4, 1, 1],
	[117, 1, 3, 9, 3, 1, 0, 0, 1, 2, 1],
	[118, 2, 4, 12, 4, 0, 0, 1, 2, 1, 1],
	[119, 1, 4, 13, 4, 0, 2, 0, 2, 2, 2],
	[120, 1, 8, 8, 8, 4, 0, 0, 0, 0, 1],
	[121, 1, 5, 19, 5, 2, 2, 0, 5, 0, 0],
	[122, 3, 7, 21, 7, 4, 1, 0, 5, 2, 0],
	[123, 1, 4, 14, 4, 3, 0, 1, 3, 2, 2],
	[124, 1, 4, 14, 4, 0, 2, 1, 2, 2, 1],
	[125, 0, 3, 14, 3, 0, 1, 1, 4, 1, 1],
	[126, 3, 4, 24, 4, 1, 1, 0, 6, 0, 2],
	[127, 3, 5, 17, 5, 2, 0, 0, 5, 1, 2],
	[128, 2, 7, 17, 7, 4, 0, 1, 5, 0, 2],
	[129, 3, 5, 19, 5, 4, 1, 0, 6, 2, 0],
	[130, 0, 4, 17, 4, 1, 2, 1, 4, 2, 2],
	[131, 2, 3, 10, 3, 3, 0, 1, 1, 0, 2],
	[132, 3, 4, 15, 4, 2, 1, 0, 4, 1, 2],
	[133, 2, 4, 25, 4, 1, 1, 0, 7, 0, 2],
	[134, 3, 4, 15, 4, 2, 2, 1, 3, 0, 0],
	[135, 2, 7, 19, 7, 4, 1, 0, 6, 0, 2],
	[136, 2, 5, 22, 5, 1, 0, 1, 7, 0, 2],
	[137, 2, 4, 16, 4, 1, 1, 1, 2, 0, 1],
	[138, 2, 5, 10, 5, 3, 2, 0, 1, 0, 2],
	[139, 0, 3, 15, 3, 0, 0, 0, 4, 1, 2],
	[140, 1, 3, 21, 3, 0, 2, 0, 6, 0, 1],
	[141, 2, 2, 11, 2, 0, 1, 1, 2, 1, 0],
	[142, 1, 3, 7, 3, 1, 1, 0, 0, 2, 1],
	[143, 4, 6, 20, 6, 4, 0, 0, 6, 0, 2],
	[144, 3, 4, 16, 4, 0, 2, 1, 3, 0, 1],
	[145, 1, 4, 25, 4, 0, 1, 0, 7, 2, 2],
	[146, 2, 6, 23, 6, 4, 1, 1, 6, 0, 2],
	[147, 1, 8, 19, 8, 4, 1, 0, 4, 2, 0],
	[148, 2, 3, 13, 3, 0, 1, 1, 3, 0, 1],
	[149, 1, 5, 16, 5, 3, 0, 1, 4, 0, 1],
	[150, 1, 5, 9, 5, 2, 2, 1, 0, 0, 0],
	[151, 1, 7, 19, 7, 4, 1, 0, 6, 0, 1],
	[152, 3, 4, 23, 4, 0, 1, 1, 6, 0, 2],
	[153, 3, 3, 15, 3, 1, 2, 0, 3, 1, 1],
	[154, 1, 3, 8, 3, 1, 0, 0, 0, 1, 2],
	[155, 2, 4, 22, 4, 3, 0, 0, 7, 1, 2],
	[156, 3, 3, 16, 3, 0, 1, 1, 5, 0, 1],
	[157, 1, 3, 22, 3, 1, 0, 1, 7, 1, 1],
	[158, 1, 7, 18, 7, 4, 1, 0, 3, 1, 2],
	[159, 2, 4, 15, 4, 2, 2, 1, 3, 2, 0],
	[160, 2, 2, 15, 2, 1, 1, 1, 4, 1, 0],
	[161, 3, 4, 18, 4, 1, 1, 0, 3, 0, 2],
	[162, 1, 6, 11, 6, 4, 1, 0, 2, 1, 1],
	[163, 1, 5, 19, 5, 3, 1, 1, 4, 0, 1],
	[164, 2, 8, 18, 8, 4, 1, 0, 3, 0, 0],
	[165, 1, 3, 14, 3, 0, 1, 1, 4, 1, 2],
	[166, 2, 3, 12, 3, 3, 0, 0, 2, 1, 0],
	[167, 2, 4, 14, 4, 2, 2, 1, 2, 2, 0],
	[168, 1, 4, 16, 4, 3, 0, 1, 4, 0, 0],
	[169, 3, 5, 19, 5, 3, 2, 0, 5, 2, 2],
	[170, 1, 3, 11, 3, 1, 2, 0, 1, 2, 1],
	[171, 3, 3, 15, 3, 1, 1, 1, 4, 1, 2],
	[172, 2, 2, 18, 2, 0, 0, 1, 5, 1, 2],
	[173, 1, 3, 22, 3, 1, 0, 0, 7, 2, 1],
	[174, 2, 6, 12, 6, 4, 0, 0, 2, 0, 1],
	[175, 1, 3, 8, 3, 0, 0, 0, 0, 1, 2],
	[176, 4, 4, 24, 4, 2, 1, 0, 6, 1, 2],
	[177, 5, 5, 25, 5, 1, 1, 1, 7, 2, 1],
	[178, 2, 3, 14, 3, 1, 0, 0, 3, 1, 0],
	[179, 2, 6, 26, 6, 4, 1, 1, 7, 2, 0],
	[180, 1, 3, 7, 3, 0, 1, 0, 0, 2, 1],
	[181, 4, 3, 20, 3, 1, 0, 1, 6, 1, 2],
	[182, 1, 6, 18, 6, 3, 0, 1, 5, 2, 0],
	[183, 1, 4, 21, 4, 0, 1, 1, 5, 1, 2],
	[184, 3, 7, 18, 7, 4, 1, 1, 3, 0, 2],
	[185, 2, 4, 14, 4, 3, 2, 0, 2, 1, 0],
	[186, 1, 3, 15, 3, 1, 0, 0, 4, 2, 0],
	[187, 1, 6, 12, 6, 4, 0, 0, 2, 2, 2],
	[188, 3, 4, 16, 4, 0, 2, 0, 3, 0, 2],
	[189, 2, 4, 13, 4, 3, 2, 1, 2, 2, 1],
	[190, 1, 4, 7, 4, 2, 1, 0, 0, 2, 1],
	[191, 1, 6, 14, 6, 4, 2, 0, 2, 0, 2],
	[192, 1, 3, 7, 3, 1, 1, 0, 0, 2, 1],
	[193, 2, 6, 11, 6, 4, 2, 1, 1, 2, 0],
	[194, 1, 3, 9, 3, 1, 2, 0, 0, 1, 0],
	[195, 1, 3, 7, 3, 2, 1, 0, 0, 2, 2],
	[196, 2, 7, 16, 7, 4, 2, 1, 3, 1, 0],
	[197, 2, 7, 13, 7, 4, 1, 0, 3, 0, 1],
	[198, 1, 6, 13, 6, 3, 2, 1, 2, 2, 0],
	[199, 1, 7, 9, 7, 4, 2, 1, 0, 0, 2],
	[200, 1, 3, 9, 3, 0, 1, 0, 1, 2, 0],
	[201, 1, 2, 8, 2, 1, 0, 1, 0, 1, 2],
	[202, 3, 3, 21, 3, 3, 2, 1, 6, 2, 1],
	[203, 3, 6, 21, 6, 4, 0, 1, 7, 2, 2],
	[204, 1, 6, 7, 6, 3, 1, 0, 0, 1, 0],
	[205, 3, 4, 16, 4, 2, 2, 0, 3, 2, 0],
	[206, 1, 3, 9, 3, 0, 2, 0, 0, 0, 1],
	[207, 0, 4, 25, 4, 2, 1, 0, 7, 2, 2],
	[208, 1, 4, 20, 4, 2, 1, 1, 7, 1, 0],
	[209, 2, 6, 17, 6, 4, 0, 0, 5, 2, 1],
	[210, 2, 3, 12, 3, 0, 0, 1, 2, 2, 0],
	[211, 1, 8, 11, 8, 4, 2, 0, 1, 2, 0],
	[212, 1, 5, 20, 5, 3, 0, 1, 6, 1, 0],
	[213, 1, 4, 26, 4, 1, 1, 1, 7, 0, 0],
	[214, 1, 3, 14, 3, 0, 0, 0, 3, 1, 1],
	[215, 1, 7, 9, 7, 4, 2, 1, 0, 2, 0],
	[216, 2, 3, 17, 3, 0, 0, 1, 5, 2, 0],
	[217, 2, 3, 13, 3, 3, 2, 1, 2, 0, 0],
	[218, 2, 3, 20, 3, 0, 0, 0, 6, 0, 0],
	[219, 2, 3, 13, 3, 0, 1, 0, 3, 2, 1],
	[220, 1, 3, 17, 3, 0, 2, 0, 4, 1, 2],
	[221, 3, 8, 26, 8, 4, 1, 0, 7, 0, 1],
	[222, 3, 7, 20, 7, 4, 0, 0, 6, 2, 2],
	[223, 1, 6, 7, 6, 4, 1, 0, 0, 2, 1],
	[224, 1, 5, 11, 5, 3, 2, 1, 1, 0, 1],
	[225, 1, 5, 7, 5, 3, 1, 1, 0, 0, 1],
	[226, 1, 5, 16, 5, 2, 1, 0, 5, 0, 0],
	[227, 1, 5, 16, 5, 4, 0, 0, 4, 2, 1],
	[228, 2, 6, 16, 6, 3, 1, 0, 5, 1, 2],
	[229, 2, 8, 11, 8, 4, 2, 0, 1, 1, 1],
	[230, 1, 3, 8, 3, 1, 0, 0, 0, 0, 0],
	[231, 1, 3, 10, 3, 0, 0, 0, 1, 2, 1],
	[232, 1, 3, 22, 3, 1, 0, 0, 7, 1, 2],
	[233, 1, 5, 19, 5, 3, 2, 1, 5, 0, 0],
	[234, 1, 8, 11, 8, 4, 1, 1, 2, 0, 1],
	[235, 3, 4, 23, 4, 0, 2, 1, 7, 1, 0],
	[236, 2, 3, 17, 3, 0, 0, 0, 5, 0, 0],
	[237, 0, 7, 19, 7, 4, 0, 0, 6, 1, 2],
	[238, 1, 8, 9, 8, 4, 0, 1, 1, 1, 2],
	[239, 1, 8, 9, 8, 4, 1, 1, 1, 0, 2],
	[240, 0, 4, 15, 4, 2, 0, 0, 4, 2, 0],
	[241, 3, 3, 16, 3, 2, 1, 1, 5, 1, 1],
	[242, 0, 8, 19, 8, 4, 1, 0, 4, 2, 1],
	[243, 1, 3, 14, 3, 0, 0, 1, 3, 2, 1],
	[244, 3, 4, 18, 4, 3, 1, 0, 3, 2, 0],
	[245, 3, 5, 22, 5, 2, 0, 0, 7, 2, 1],
	[246, 1, 5, 16, 5, 2, 1, 1, 2, 0, 1],
	[247, 0, 4, 15, 4, 2, 0, 0, 4, 1, 1],
	[248, 2, 5, 17, 5, 3, 0, 0, 5, 0, 0],
	[249, 2, 4, 11, 4, 2, 2, 1, 1, 1, 0],
	[250, 1, 4, 9, 4, 3, 2, 1, 0, 1, 1],
	[251, 2, 3, 13, 3, 1, 1, 1, 3, 1, 0],
	[252, 1, 5, 11, 5, 3, 2, 1, 1, 0, 0],
	[253, 1, 4, 16, 4, 0, 2, 1, 3, 2, 0],
	[254, 3, 5, 19, 5, 3, 1, 1, 6, 1, 0],
	[255, 2, 8, 23, 8, 4, 2, 1, 7, 2, 0],
	[256, 2, 4, 21, 4, 2, 1, 0, 5, 0, 0],
	[257, 2, 5, 14, 5, 3, 0, 0, 3, 1, 0],
	[258, 4, 5, 21, 5, 3, 2, 1, 6, 2, 1],
	[259, 1, 5, 9, 5, 3, 0, 0, 1, 2, 2],
	[260, 4, 4, 23, 4, 1, 2, 0, 7, 2, 2],
	[261, 2, 6, 12, 6, 4, 0, 1, 2, 2, 1],
	[262, 2, 5, 14, 5, 4, 0, 1, 3, 2, 2],
	[263, 2, 7, 17, 7, 4, 0, 1, 5, 0, 0],
	[264, 2, 4, 16, 4, 2, 0, 1, 4, 1, 2],
	[265, 2, 3, 20, 3, 0, 0, 0, 6, 1, 2],
	[266, 1, 3, 9, 3, 1, 2, 0, 0, 2, 2],
	[267, 3, 5, 22, 5, 3, 1, 1, 5, 2, 2],
	[268, 1, 3, 15, 3, 2, 0, 1, 4, 2, 0],
	[269, 3, 3, 15, 3, 1, 1, 1, 4, 0, 1],
	[270, 4, 3, 20, 3, 1, 0, 0, 6, 0, 2],
	[271, 2, 5, 17, 5, 4, 1, 0, 5, 0, 2],
	[272, 2, 8, 16, 8, 4, 1, 1, 2, 1, 1],
	[273, 2, 4, 18, 4, 1, 1, 1, 3, 2, 1],
	[274, 1, 3, 7, 3, 1, 1, 0, 0, 2, 0],
	[275, 3, 3, 21, 3, 0, 2, 0, 6, 0, 0],
	[276, 2, 3, 14, 3, 1, 1, 1, 4, 1, 0],
	[277, 1, 4, 8, 4, 2, 1, 1, 1, 0, 0],
	[278, 1, 3, 18, 3, 1, 2, 0, 5, 0, 2],
	[279, 2, 5, 12, 5, 3, 0, 1, 2, 2, 2],
	[280, 4, 4, 22, 4, 1, 2, 1, 6, 1, 2],
	[281, 2, 3, 17, 3, 1, 0, 0, 5, 0, 2],
	[282, 0, 6, 19, 6, 3, 0, 1, 6, 0, 0],
	[283, 1, 4, 9, 4, 2, 2, 0, 0, 2, 0],
	[284, 2, 4, 14, 4, 1, 2, 1, 2, 0, 0],
	[285, 3, 4, 23, 4, 1, 2, 1, 7, 0, 0],
	[286, 2, 5, 21, 5, 1, 1, 1, 7, 2, 2],
	[287, 3, 4, 24, 4, 2, 1, 1, 6, 2, 2],
	[288, 1, 5, 14, 5, 3, 0, 0, 3, 2, 1],
	[289, 3, 5, 21, 5, 3, 1, 1, 5, 1, 0],
	[290, 1, 3, 19, 3, 0, 2, 1, 5, 2, 2],
	[291, 3, 6, 24, 6, 3, 1, 1, 6, 2, 1],
	[292, 1, 5, 9, 5, 3, 0, 1, 1, 1, 1],
	[293, 1, 4, 20, 4, 1, 2, 1, 5, 2, 0],
	[294, 1, 6, 22, 6, 3, 0, 0, 7, 2, 1],
	[295, 1, 6, 9, 6, 4, 2, 0, 0, 0, 2],
	[296, 1, 7, 10, 7, 4, 0, 0, 1, 2, 0],
	[297, 1, 3, 13, 3, 1, 2, 1, 2, 0, 2],
	[298, 1, 3, 13, 3, 0, 2, 0, 2, 1, 2],
	[299, 1, 3, 14, 3, 0, 0, 0, 3, 2, 0],
	[300, 1, 5, 7, 5, 2, 1, 0, 0, 1, 1],
	[301, 2, 4, 14, 4, 2, 0, 1, 3, 1, 0],
	[302, 2, 5, 10, 5, 3, 0, 0, 1, 2, 1],
	[303, 2, 3, 13, 3, 1, 1, 1, 3, 1, 1],
	[304, 3, 5, 21, 5, 0, 0, 1, 7, 0, 0],
	[305, 2, 3, 10, 3, 2, 2, 1, 1, 2, 2],
	[306, 1, 4, 19, 4, 2, 1, 0, 4, 0, 1],
	[307, 1, 8, 15, 8, 4, 2, 1, 3, 0, 0],
	[308, 1, 3, 9, 3, 3, 2, 0, 0, 2, 0],
	[309, 1, 3, 9, 3, 0, 0, 0, 1, 0, 0],
	[310, 1, 5, 15, 5, 3, 0, 0, 4, 1, 0],
	[311, 2, 7, 16, 7, 4, 2, 0, 3, 0, 2],
	[312, 0, 4, 17, 4, 3, 2, 0, 4, 2, 2],
	[313, 3, 4, 22, 4, 1, 2, 1, 7, 2, 1],
	[314, 2, 3, 16, 3, 1, 1, 1, 5, 2, 0],
	[315, 2, 6, 12, 6, 3, 0, 0, 2, 0, 1],
	[316, 1, 5, 9, 5, 3, 2, 1, 0, 2, 1],
	[317, 2, 3, 16, 3, 0, 1, 1, 5, 2, 0],
	[318, 2, 4, 18, 4, 0, 1, 0, 3, 0, 0],
	[319, 3, 4, 22, 4, 1, 2, 1, 6, 0, 1],
	[320, 1, 5, 9, 5, 3, 2, 1, 0, 0, 0],
	[321, 1, 6, 9, 6, 4, 2, 1, 0, 1, 2],
	[322, 1, 6, 18, 6, 4, 1, 0, 3, 2, 0],
	[323, 2, 3, 13, 3, 1, 1, 1, 3, 1, 2],
	[324, 1, 4, 10, 4, 2, 0, 0, 1, 1, 1],
	[325, 4, 4, 22, 4, 1, 2, 0, 6, 1, 0],
	[326, 1, 3, 8, 3, 0, 0, 0, 0, 0, 1],
	[327, 1, 4, 23, 4, 1, 2, 1, 7, 2, 0],
	[328, 1, 3, 8, 3, 0, 0, 0, 0, 0, 2],
	[329, 1, 3, 17, 3, 0, 0, 1, 5, 0, 0],
	[330, 1, 4, 9, 4, 2, 1, 1, 1, 0, 1],
	[331, 1, 4, 14, 4, 2, 0, 1, 3, 2, 2],
	[332, 2, 4, 19, 4, 0, 1, 0, 4, 0, 1],
	[333, 1, 7, 19, 7, 4, 2, 1, 5, 1, 0],
	[334, 1, 5, 9, 5, 3, 1, 1, 1, 1, 0],
	[335, 2, 3, 14, 3, 3, 0, 1, 3, 1, 1],
	[336, 1, 3, 9, 3, 1, 2, 1, 0, 1, 1],
	[337, 1, 4, 9, 4, 3, 0, 0, 1, 2, 1],
	[338, 2, 3, 23, 3, 1, 2, 0, 7, 1, 1],
	[339, 1, 2, 7, 2, 0, 1, 1, 0, 0, 0],
	[340, 2, 3, 15, 3, 2, 0, 1, 4, 0, 2],
	[341, 0, 7, 19, 7, 4, 0, 0, 6, 2, 2],
	[342, 2, 3, 12, 3, 1, 0, 1, 2, 2, 0],
	[343, 1, 4, 22, 4, 1, 0, 1, 7, 1, 0],
	[344, 1, 3, 16, 3, 0, 1, 1, 5, 1, 1],
	[345, 0, 7, 18, 7, 4, 1, 1, 6, 0, 0],
	[346, 1, 3, 11, 3, 2, 2, 1, 1, 1, 0],
	[347, 3, 5, 16, 5, 4, 1, 1, 2, 0, 1],
	[348, 2, 6, 10, 6, 4, 0, 1, 1, 1, 1],
	[349, 1, 7, 18, 7, 4, 1, 0, 3, 1, 0],
	[350, 3, 6, 21, 6, 3, 1, 0, 5, 2, 2],
	[351, 0, 5, 19, 5, 3, 1, 0, 4, 2, 2],
	[352, 3, 4, 24, 4, 0, 2, 1, 7, 0, 1],
	[353, 1, 3, 11, 3, 1, 2, 1, 1, 2, 1],
	[354, 1, 3, 9, 3, 0, 2, 1, 0, 1, 2],
	[355, 2, 4, 16, 4, 0, 2, 1, 3, 1, 0],
	[356, 4, 4, 24, 4, 1, 2, 1, 7, 1, 2],
	[357, 0, 8, 17, 8, 4, 2, 1, 4, 1, 2],
	[358, 3, 3, 18, 3, 1, 0, 0, 5, 0, 0],
	[359, 1, 4, 20, 4, 0, 1, 0, 7, 1, 0],
	[360, 1, 7, 17, 7, 4, 1, 1, 5, 1, 1],
	[361, 1, 7, 9, 7, 4, 1, 0, 1, 2, 0],
	[362, 4, 4, 22, 4, 3, 2, 0, 6, 0, 1],
	[363, 2, 5, 11, 5, 2, 1, 0, 2, 0, 0],
	[364, 2, 3, 11, 3, 0, 1, 0, 2, 1, 0],
	[365, 1, 6, 9, 6, 3, 2, 0, 0, 0, 2],
	[366, 1, 3, 8, 3, 3, 0, 1, 0, 1, 1],
	[367, 0, 3, 15, 3, 2, 0, 1, 4, 2, 0],
	[368, 2, 7, 18, 7, 4, 0, 0, 5, 1, 1],
	[369, 1, 4, 9, 4, 2, 1, 0, 1, 2, 2],
	[370, 2, 3, 17, 3, 0, 0, 1, 5, 1, 2],
	[371, 1, 3, 8, 3, 2, 0, 1, 0, 0, 1],
	[372, 1, 4, 21, 4, 2, 1, 1, 5, 2, 2],
	[373, 1, 7, 16, 7, 4, 1, 0, 5, 1, 1],
	[374, 1, 3, 8, 3, 2, 0, 0, 0, 1, 0],
	[375, 1, 3, 9, 3, 0, 2, 1, 0, 2, 1],
	[376, 1, 3, 20, 3, 1, 0, 0, 6, 2, 0],
	[377, 0, 8, 21, 8, 4, 2, 1, 6, 1, 1],
	[378, 1, 5, 23, 5, 3, 2, 1, 7, 2, 1],
	[379, 2, 3, 22, 3, 1, 0, 1, 7, 0, 2],
	[380, 1, 3, 11, 3, 0, 2, 1, 1, 1, 0],
	[381, 3, 4, 24, 4, 2, 2, 1, 7, 2, 0],
	[382, 4, 4, 20, 4, 0, 1, 1, 4, 0, 1],
	[383, 2, 3, 18, 3, 1, 0, 0, 5, 2, 1],
	[384, 2, 5, 16, 5, 3, 0, 0, 4, 0, 0],
	[385, 2, 3, 11, 3, 1, 2, 0, 1, 0, 1],
	[386, 1, 6, 22, 6, 3, 0, 0, 7, 2, 2],
	[387, 2, 4, 10, 4, 3, 2, 1, 1, 2, 0],
	[388, 2, 4, 21, 4, 2, 0, 1, 7, 2, 2],
	[389, 3, 2, 21, 2, 1, 1, 1, 7, 2, 2],
	[390, 2, 7, 16, 7, 4, 2, 0, 3, 2, 0],
	[391, 1, 3, 7, 3, 0, 1, 0, 0, 1, 1],
	[392, 0, 5, 19, 5, 4, 0, 1, 6, 1, 2],
	[393, 3, 3, 19, 3, 0, 1, 1, 6, 1, 2],
	[394, 2, 5, 11, 5, 3, 2, 0, 1, 1, 1],
	[395, 1, 8, 8, 8, 4, 1, 1, 1, 2, 1],
	[396, 1, 8, 9, 8, 4, 1, 0, 1, 0, 0],
	[397, 4, 7, 24, 7, 4, 1, 1, 6, 0, 1],
	[398, 2, 6, 20, 6, 3, 1, 0, 4, 2, 0],
	[399, 1, 3, 16, 3, 2, 1, 0, 5, 0, 0],
	[400, 1, 4, 14, 4, 0, 2, 0, 2, 2, 2],
	[401, 2, 5, 14, 5, 2, 0, 0, 3, 1, 1],
	[402, 3, 4, 19, 4, 1, 1, 1, 4, 2, 0],
	[403, 0, 7, 15, 7, 4, 0, 0, 4, 2, 1],
	[404, 1, 3, 7, 3, 1, 1, 0, 0, 2, 0],
	[405, 1, 3, 11, 3, 0, 2, 1, 1, 1, 0],
	[406, 2, 4, 22, 4, 3, 0, 0, 7, 1, 0],
	[407, 3, 3, 16, 3, 0, 0, 0, 4, 1, 1],
	[408, 3, 5, 20, 5, 3, 1, 0, 4, 1, 0],
	[409, 2, 5, 10, 5, 2, 0, 1, 1, 1, 2],
	[410, 2, 8, 15, 8, 4, 2, 0, 3, 2, 2],
	[411, 2, 8, 13, 8, 4, 1, 0, 3, 1, 2],
	[412, 2, 4, 15, 4, 3, 1, 0, 4, 1, 0],
	[413, 1, 3, 20, 3, 1, 0, 1, 6, 0, 1],
	[414, 2, 8, 23, 8, 4, 2, 1, 7, 0, 0],
	[415, 4, 4, 22, 4, 2, 2, 0, 7, 2, 0],
	[416, 2, 3, 13, 3, 0, 2, 1, 2, 1, 0],
	[417, 1, 2, 9, 2, 0, 1, 1, 1, 1, 0],
	[418, 0, 6, 20, 6, 4, 2, 1, 6, 1, 1],
	[419, 4, 7, 22, 7, 4, 0, 1, 7, 2, 2],
	[420, 1, 3, 18, 3, 0, 0, 0, 5, 2, 0],
	[421, 1, 4, 14, 4, 3, 0, 0, 3, 0, 2],
	[422, 3, 3, 16, 3, 2, 0, 0, 4, 0, 0],
	[423, 0, 3, 14, 3, 2, 1, 1, 4, 2, 2],
	[424, 2, 4, 14, 4, 3, 0, 0, 3, 2, 2],
	[425, 2, 8, 18, 8, 4, 2, 1, 5, 0, 0],
	[426, 2, 3, 14, 3, 1, 0, 1, 3, 0, 2],
	[427, 1, 3, 13, 3, 0, 2, 1, 2, 1, 0],
	[428, 1, 4, 18, 4, 2, 1, 1, 3, 1, 1],
	[429, 2, 4, 18, 4, 2, 2, 0, 5, 0, 0],
	[430, 2, 4, 12, 4, 2, 0, 0, 2, 2, 1],
	[431, 1, 7, 7, 7, 4, 1, 0, 0, 0, 1],
	[432, 2, 4, 17, 4, 1, 2, 0, 4, 0, 1],
	[433, 2, 4, 18, 4, 1, 2, 1, 4, 1, 0],
	[434, 2, 5, 19, 5, 3, 1, 1, 4, 0, 1],
	[435, 1, 3, 8, 3, 2, 1, 1, 1, 0, 0],
	[436, 2, 6, 11, 6, 3, 1, 1, 2, 2, 2],
	[437, 2, 7, 18, 7, 4, 2, 0, 5, 0, 2],
	[438, 1, 4, 9, 4, 2, 1, 1, 1, 0, 0],
	[439, 1, 5, 9, 5, 3, 2, 1, 0, 2, 2],
	[440, 2, 8, 17, 8, 4, 0, 1, 5, 2, 1],
	[441, 3, 3, 21, 3, 2, 2, 0, 6, 2, 0],
	[442, 1, 2, 12, 2, 0, 0, 1, 2, 2, 0],
	[443, 1, 8, 7, 8, 4, 1, 1, 0, 0, 1],
	[444, 1, 3, 9, 3, 1, 1, 1, 1, 1, 2],
	[445, 1, 3, 14, 3, 0, 0, 0, 3, 2, 0],
	[446, 2, 4, 14, 4, 3, 0, 0, 3, 2, 2],
	[447, 1, 2, 8, 2, 0, 0, 1, 0, 1, 2],
	[448, 2, 5, 22, 5, 3, 0, 1, 7, 2, 0],
	[449, 1, 4, 16, 4, 2, 2, 1, 3, 1, 1],
	[450, 1, 3, 14, 3, 0, 0, 1, 3, 1, 2],
	[451, 0, 3, 18, 3, 2, 1, 1, 6, 2, 1],
	[452, 4, 5, 21, 5, 3, 1, 0, 7, 0, 1],
	[453, 1, 7, 16, 7, 4, 1, 0, 2, 2, 1],
	[454, 3, 5, 22, 5, 4, 2, 0, 7, 0, 1],
	[455, 4, 3, 22, 3, 1, 2, 0, 7, 1, 2],
	[456, 1, 3, 9, 3, 0, 2, 0, 0, 1, 2],
	[457, 1, 3, 21, 3, 0, 1, 0, 7, 2, 2],
	[458, 1, 4, 14, 4, 0, 2, 0, 2, 0, 0],
	[459, 1, 3, 17, 3, 0, 1, 1, 5, 2, 1],
	[460, 1, 3, 15, 3, 0, 0, 0, 4, 0, 0],
	[461, 1, 2, 12, 2, 0, 0, 1, 2, 1, 1],
	[462, 1, 2, 7, 2, 0, 1, 1, 0, 2, 2],
	[463, 1, 2, 7, 2, 0, 1, 1, 0, 0, 2],
	[464, 2, 6, 14, 6, 3, 0, 0, 3, 0, 1],
	[465, 1, 8, 11, 8, 4, 2, 0, 1, 2, 2],
	[466, 0, 6, 16, 6, 3, 0, 1, 4, 0, 0],
	[467, 2, 5, 19, 5, 4, 2, 0, 5, 0, 0],
	[468, 2, 7, 11, 7, 4, 1, 0, 2, 0, 0],
	[469, 1, 4, 18, 4, 3, 2, 1, 4, 1, 0],
	[470, 0, 8, 14, 8, 4, 1, 0, 4, 0, 0],
	[471, 2, 3, 10, 3, 0, 2, 0, 1, 2, 0],
	[472, 3, 4, 18, 4, 0, 2, 0, 4, 1, 2],
	[473, 1, 4, 21, 4, 2, 1, 0, 5, 0, 2],
	[474, 1, 3, 15, 3, 0, 0, 1, 4, 2, 0],
	[475, 3, 4, 16, 4, 1, 1, 0, 2, 0, 2],
	[476, 1, 8, 10, 8, 4, 0, 0, 1, 0, 1],
	[477, 0, 3, 20, 3, 0, 2, 1, 6, 0, 2],
	[478, 4, 3, 21, 3, 2, 2, 0, 6, 1, 1],
	[479, 1, 3, 14, 3, 0, 0, 0, 3, 1, 1],
	[480, 3, 5, 18, 5, 3, 1, 1, 3, 1, 2],
	[481, 4, 3, 23, 3, 0, 2, 0, 7, 2, 1],
	[482, 3, 4, 23, 4, 2, 2, 1, 7, 0, 2],
	[483, 1, 5, 26, 5, 3, 1, 0, 7, 1, 0],
	[484, 2, 2, 10, 2, 0, 0, 1, 1, 1, 0],
	[485, 1, 4, 16, 4, 0, 1, 1, 2, 1, 2],
	[486, 2, 4, 16, 4, 2, 2, 0, 3, 2, 2],
	[487, 2, 3, 11, 3, 1, 2, 1, 1, 0, 1],
	[488, 4, 5, 25, 5, 3, 1, 1, 7, 0, 1],
	[489, 1, 3, 15, 3, 0, 2, 0, 3, 1, 1],
	[490, 1, 3, 9, 3, 2, 2, 1, 0, 0, 2],
	[491, 1, 2, 12, 2, 0, 0, 1, 2, 2, 1],
	[492, 1, 3, 14, 3, 2, 0, 0, 3, 0, 2],
	[493, 1, 5, 9, 5, 3, 2, 1, 0, 2, 2],
	[494, 2, 7, 24, 7, 4, 2, 1, 7, 1, 0],
	[495, 2, 5, 18, 5, 3, 2, 0, 5, 2, 1],
	[496, 2, 3, 17, 3, 1, 0, 1, 5, 1, 0],
	[497, 4, 6, 23, 6, 3, 2, 1, 7, 0, 0],
	[498, 1, 3, 9, 3, 0, 1, 0, 1, 2, 1],
	[499, 1, 8, 19, 8, 4, 1, 0, 4, 0, 0],
	[500, 2, 5, 20, 5, 2, 1, 1, 4, 2, 0],
	[501, 2, 3, 12, 3, 2, 0, 1, 2, 1, 0],
	[502, 4, 5, 24, 5, 0, 2, 1, 7, 1, 0],
	[503, 1, 5, 11, 5, 2, 1, 0, 2, 2, 2],
	[504, 2, 8, 22, 8, 4, 2, 0, 6, 2, 0],
	[505, 3, 5, 21, 5, 1, 1, 1, 7, 1, 1],
	[506, 1, 3, 9, 3, 0, 2, 1, 0, 2, 1],
	[507, 2, 7, 17, 7, 4, 0, 0, 5, 1, 0],
	[508, 2, 3, 13, 3, 1, 2, 0, 2, 0, 1],
	[509, 3, 5, 16, 5, 3, 2, 1, 3, 0, 0],
	[510, 4, 5, 21, 5, 3, 1, 1, 5, 2, 2],
	[511, 2, 3, 12, 3, 1, 0, 0, 2, 1, 1],
	[512, 2, 5, 10, 5, 2, 2, 0, 1, 0, 1],
	[513, 2, 5, 24, 5, 3, 1, 1, 6, 1, 1],
	[514, 2, 4, 22, 4, 0, 1, 1, 5, 0, 0],
	[515, 1, 3, 16, 3, 2, 1, 1, 5, 1, 2],
	[516, 1, 5, 8, 5, 3, 0, 0, 0, 1, 1],
	[517, 1, 2, 19, 2, 0, 1, 1, 6, 2, 1],
	[518, 2, 5, 22, 5, 3, 0, 1, 7, 1, 1],
	[519, 1, 3, 16, 3, 1, 0, 1, 4, 2, 0],
	[520, 1, 3, 14, 3, 0, 0, 1, 3, 2, 2],
	[521, 1, 3, 18, 3, 1, 2, 1, 5, 2, 0],
	[522, 1, 4, 9, 4, 2, 2, 1, 0, 1, 0],
	[523, 1, 3, 19, 3, 1, 1, 1, 6, 1, 1],
	[524, 1, 7, 16, 7, 4, 2, 0, 3, 2, 1],
	[525, 3, 7, 16, 7, 4, 2, 1, 3, 2, 1],
	[526, 1, 7, 15, 7, 4, 0, 1, 4, 0, 2],
	[527, 2, 7, 10, 7, 4, 0, 0, 1, 0, 1],
	[528, 3, 4, 16, 4, 3, 2, 1, 3, 1, 1],
	[529, 1, 6, 17, 6, 4, 2, 0, 4, 2, 2],
	[530, 1, 6, 16, 6, 3, 1, 0, 2, 2, 0],
	[531, 0, 4, 17, 4, 0, 2, 1, 4, 0, 1],
	[532, 1, 6, 10, 6, 4, 0, 1, 1, 0, 1],
	[533, 4, 5, 24, 5, 3, 2, 1, 7, 1, 2],
	[534, 2, 4, 24, 4, 0, 1, 1, 6, 0, 0],
	[535, 1, 3, 14, 3, 0, 0, 1, 3, 1, 0],
	[536, 3, 4, 15, 4, 3, 2, 0, 3, 0, 0],
	[537, 1, 4, 20, 4, 3, 0, 0, 6, 0, 0],
	[538, 1, 3, 14, 3, 1, 0, 1, 3, 1, 2],
	[539, 3, 5, 22, 5, 2, 0, 0, 7, 2, 2],
	[540, 1, 7, 8, 7, 4, 0, 0, 0, 1, 2],
	[541, 1, 8, 8, 8, 4, 0, 1, 0, 0, 0],
	[542, 2, 6, 20, 6, 4, 1, 1, 4, 2, 0],
	[543, 2, 4, 19, 4, 1, 1, 0, 4, 1, 1],
	[544, 1, 6, 11, 6, 4, 2, 1, 1, 2, 0],
	[545, 1, 3, 9, 3, 1, 1, 0, 1, 0, 0],
	[546, 0, 4, 15, 4, 2, 0, 1, 4, 2, 1],
	[547, 2, 3, 14, 3, 1, 0, 1, 3, 2, 2],
	[548, 0, 4, 19, 4, 0, 1, 0, 4, 1, 2],
	[549, 2, 5, 11, 5, 2, 2, 0, 1, 0, 0],
	[550, 0, 3, 15, 3, 1, 1, 1, 4, 2, 0],
	[551, 1, 3, 10, 3, 1, 2, 0, 1, 0, 1],
	[552, 3, 5, 15, 5, 3, 1, 0, 4, 2, 1],
	[553, 3, 5, 17, 5, 4, 0, 1, 5, 1, 1],
	[554, 3, 4, 24, 4, 2, 2, 1, 7, 1, 2],
	[555, 3, 4, 19, 4, 0, 2, 1, 5, 2, 2],
	[556, 1, 3, 8, 3, 1, 0, 0, 0, 1, 2],
	[557, 2, 3, 14, 3, 2, 0, 0, 3, 0, 1],
	[558, 2, 8, 18, 8, 4, 1, 0, 3, 0, 2],
	[559, 1, 4, 16, 4, 2, 1, 0, 2, 2, 2],
	[560, 2, 4, 16, 4, 0, 2, 1, 3, 0, 1],
	[561, 1, 3, 9, 3, 1, 1, 0, 1, 0, 2],
	[562, 1, 8, 8, 8, 4, 0, 1, 0, 2, 1],
	[563, 1, 3, 16, 3, 2, 2, 1, 4, 0, 0],
	[564, 1, 4, 14, 4, 2, 2, 1, 2, 2, 1],
	[565, 2, 8, 13, 8, 4, 2, 1, 2, 2, 0],
	[566, 1, 4, 9, 4, 3, 2, 0, 0, 1, 2],
	[567, 1, 8, 7, 8, 4, 1, 0, 0, 2, 0],
	[568, 2, 8, 17, 8, 4, 0, 1, 5, 0, 2],
	[569, 1, 2, 8, 2, 1, 1, 1, 1, 1, 0],
	[570, 1, 3, 9, 3, 2, 2, 1, 0, 1, 2],
	[571, 1, 3, 12, 3, 0, 0, 0, 2, 1, 1],
	[572, 1, 6, 8, 6, 4, 1, 1, 1, 0, 1],
	[573, 2, 3, 12, 3, 0, 0, 1, 2, 2, 2],
	[574, 1, 6, 11, 6, 3, 2, 1, 1, 1, 2],
	[575, 1, 5, 9, 5, 3, 2, 0, 0, 0, 0],
	[576, 1, 4, 20, 4, 2, 1, 1, 4, 2, 2],
	[577, 2, 5, 11, 5, 3, 1, 1, 2, 0, 2],
	[578, 1, 7, 17, 7, 4, 0, 1, 5, 2, 2],
	[579, 1, 3, 17, 3, 0, 2, 0, 4, 1, 1],
	[580, 1, 8, 10, 8, 4, 2, 1, 1, 1, 1],
	[581, 1, 2, 14, 2, 1, 1, 1, 4, 2, 1],
	[582, 1, 7, 16, 7, 4, 1, 1, 2, 0, 1],
	[583, 2, 4, 16, 4, 3, 2, 1, 3, 1, 1],
	[584, 3, 3, 22, 3, 0, 0, 1, 7, 2, 0],
	[585, 3, 3, 15, 3, 0, 2, 1, 3, 2, 2],
	[586, 1, 5, 20, 5, 3, 0, 1, 6, 1, 1],
	[587, 4, 4, 21, 4, 2, 1, 1, 5, 1, 2],
	[588, 2, 3, 14, 3, 2, 0, 0, 3, 2, 1],
	[589, 1, 5, 12, 5, 4, 0, 0, 2, 0, 2],
	[590, 0, 6, 21, 6, 3, 0, 1, 7, 0, 2],
	[591, 2, 3, 14, 3, 1, 0, 0, 3, 2, 1],
	[592, 3, 4, 24, 4, 1, 1, 1, 6, 2, 0],
	[593, 2, 3, 11, 3, 1, 2, 0, 1, 2, 0],
	[594, 1, 3, 10, 3, 1, 0, 1, 1, 2, 0],
	[595, 2, 7, 22, 7, 4, 2, 0, 6, 1, 1],
	[596, 3, 5, 23, 5, 2, 2, 0, 7, 2, 1],
	[597, 3, 6, 18, 6, 3, 1, 1, 3, 1, 1],
	[598, 2, 3, 14, 3, 1, 0, 1, 3, 0, 2],
	[599, 2, 3, 17, 3, 2, 0, 0, 5, 0, 1],
	[600, 1, 3, 14, 3, 0, 0, 0, 3, 1, 2],
	[601, 2, 4, 19, 4, 1, 2, 1, 5, 1, 2],
	[602, 2, 4, 21, 4, 0, 1, 0, 5, 1, 2],
	[603, 2, 5, 17, 5, 3, 2, 1, 4, 0, 2],
	[604, 2, 5, 16, 5, 3, 2, 1, 3, 2, 1],
	[605, 4, 5, 25, 5, 4, 1, 0, 7, 1, 1],
	[606, 3, 3, 17, 3, 0, 0, 0, 5, 0, 1],
	[607, 1, 5, 8, 5, 4, 0, 1, 0, 2, 0],
	[608, 2, 8, 15, 8, 4, 0, 1, 4, 2, 1],
	[609, 1, 6, 10, 6, 3, 0, 1, 1, 1, 0],
	[610, 2, 4, 17, 4, 1, 2, 0, 4, 2, 1],
	[611, 3, 5, 21, 5, 0, 1, 0, 7, 2, 2],
	[612, 3, 3, 16, 3, 0, 1, 0, 5, 1, 0],
	[613, 0, 3, 14, 3, 0, 1, 1, 4, 1, 2],
	[614, 1, 3, 15, 3, 0, 0, 1, 4, 0, 0],
	[615, 1, 4, 11, 4, 2, 1, 1, 2, 1, 2],
	[616, 1, 7, 7, 7, 4, 1, 0, 0, 1, 0],
	[617, 2, 4, 18, 4, 2, 1, 0, 3, 0, 2],
	[618, 1, 3, 8, 3, 3, 1, 1, 1, 2, 2],
	[619, 2, 6, 13, 6, 4, 1, 1, 3, 1, 2],
	[620, 1, 4, 20, 4, 2, 1, 0, 4, 2, 0],
	[621, 1, 7, 21, 7, 4, 0, 0, 7, 0, 1],
	[622, 3, 3, 22, 3, 1, 0, 1, 7, 0, 0],
	[623, 1, 4, 23, 4, 0, 2, 1, 7, 0, 2],
	[624, 1, 5, 23, 5, 2, 2, 1, 7, 2, 2],
	[625, 1, 3, 14, 3, 2, 0, 1, 3, 0, 2],
	[626, 1, 3, 12, 3, 0, 0, 0, 2, 0, 1],
	[627, 1, 2, 8, 2, 0, 1, 1, 1, 2, 1],
	[628, 1, 5, 18, 5, 3, 1, 1, 6, 0, 0],
	[629, 2, 4, 22, 4, 1, 2, 0, 7, 0, 0],
	[630, 3, 6, 16, 6, 3, 0, 0, 4, 1, 1],
	[631, 3, 7, 22, 7, 4, 0, 1, 7, 1, 1],
	[632, 2, 4, 18, 4, 1, 1, 0, 3, 2, 1],
	[633, 2, 3, 11, 3, 0, 1, 0, 2, 0, 0],
	[634, 1, 3, 19, 3, 2, 1, 1, 6, 2, 1],
	[635, 3, 5, 24, 5, 3, 2, 1, 7, 2, 0],
	[636, 1, 3, 7, 3, 1, 1, 0, 0, 2, 0],
	[637, 1, 8, 9, 8, 4, 2, 0, 0, 2, 1],
	[638, 2, 3, 18, 3, 0, 0, 0, 5, 0, 2],
	[639, 1, 3, 9, 3, 1, 0, 1, 1, 2, 2],
	[640, 1, 3, 7, 3, 0, 1, 0, 0, 1, 0],
	[641, 2, 4, 19, 4, 2, 1, 1, 6, 2, 2],
	[642, 1, 5, 8, 5, 4, 0, 1, 0, 0, 1],
	[643, 1, 4, 19, 4, 0, 1, 1, 7, 0, 1],
	[644, 2, 4, 12, 4, 2, 0, 1, 2, 0, 1],
	[645, 2, 4, 21, 4, 1, 1, 1, 5, 0, 2],
	[646, 1, 6, 7, 6, 4, 1, 1, 0, 0, 2],
	[647, 4, 4, 26, 4, 0, 1, 1, 7, 0, 0],
	[648, 1, 4, 16, 4, 0, 1, 1, 2, 1, 0],
	[649, 2, 4, 21, 4, 3, 0, 0, 7, 1, 1],
	[650, 4, 4, 22, 4, 0, 2, 0, 6, 0, 1],
	[651, 0, 4, 20, 4, 1, 1, 0, 7, 0, 2],
	[652, 0, 3, 19, 3, 2, 0, 1, 6, 1, 2],
	[653, 1, 4, 20, 4, 3, 1, 0, 4, 2, 1],
	[654, 1, 2, 10, 2, 0, 0, 1, 1, 0, 0],
	[655, 2, 3, 10, 3, 0, 0, 0, 1, 2, 1],
	[656, 1, 6, 9, 6, 3, 2, 0, 0, 0, 2],
	[657, 1, 4, 26, 4, 0, 1, 0, 7, 0, 0],
	[658, 3, 4, 19, 4, 3, 1, 1, 6, 0, 1],
	[659, 1, 3, 17, 3, 0, 2, 0, 4, 0, 0],
	[660, 0, 7, 20, 7, 4, 2, 1, 6, 2, 0],
	[661, 1, 3, 15, 3, 0, 1, 1, 4, 0, 2],
	[662, 4, 7, 23, 7, 4, 2, 1, 7, 0, 2],
	[663, 1, 4, 14, 4, 3, 0, 1, 3, 2, 1],
	[664, 2, 6, 10, 6, 3, 0, 0, 1, 0, 2],
	[665, 1, 4, 21, 4, 0, 2, 0, 6, 1, 0],
	[666, 1, 5, 10, 5, 3, 0, 1, 1, 1, 1],
	[667, 3, 3, 16, 3, 1, 1, 1, 5, 1, 0],
	[668, 1, 5, 9, 5, 3, 1, 0, 1, 2, 1],
	[669, 3, 4, 19, 4, 0, 1, 1, 4, 1, 1],
	[670, 1, 5, 7, 5, 3, 1, 1, 0, 1, 2],
	[671, 2, 5, 20, 5, 3, 0, 1, 6, 2, 2],
	[672, 4, 3, 21, 3, 1, 2, 1, 6, 0, 0],
	[673, 1, 2, 8, 2, 1, 1, 1, 1, 0, 1],
	[674, 1, 2, 7, 2, 1, 1, 1, 0, 2, 1],
	[675, 2, 3, 18, 3, 1, 2, 1, 5, 1, 2],
	[676, 1, 3, 9, 3, 2, 1, 1, 1, 2, 1],
	[677, 3, 8, 21, 8, 4, 0, 1, 7, 2, 2],
	[678, 4, 4, 25, 4, 2, 1, 1, 7, 0, 2],
	[679, 1, 6, 9, 6, 3, 1, 0, 1, 2, 2],
	[680, 0, 7, 15, 7, 4, 0, 0, 4, 0, 1],
	[681, 1, 5, 17, 5, 2, 2, 0, 4, 0, 2],
	[682, 0, 3, 14, 3, 1, 1, 0, 4, 2, 0],
	[683, 1, 3, 11, 3, 3, 2, 1, 1, 2, 0],
	[684, 4, 5, 21, 5, 0, 1, 1, 7, 0, 2],
	[685, 2, 4, 11, 4, 2, 2, 0, 1, 1, 2],
	[686, 3, 4, 16, 4, 2, 2, 1, 3, 1, 2],
	[687, 2, 6, 14, 6, 4, 0, 1, 3, 2, 0],
	[688, 1, 4, 7, 4, 3, 1, 1, 0, 0, 0],
	[689, 1, 3, 9, 3, 1, 2, 1, 0, 0, 2],
	[690, 1, 4, 19, 4, 1, 2, 0, 5, 1, 2],
	[691, 1, 5, 9, 5, 2, 0, 0, 1, 2, 0],
	[692, 2, 7, 12, 7, 4, 0, 0, 2, 0, 1],
	[693, 3, 3, 17, 3, 0, 0, 1, 5, 2, 2],
	[694, 3, 4, 18, 4, 2, 2, 1, 4, 1, 0],
	[695, 1, 4, 13, 4, 0, 2, 0, 2, 2, 2],
	[696, 1, 4, 13, 4, 1, 2, 0, 2, 2, 0],
	[697, 2, 4, 23, 4, 1, 1, 1, 6, 0, 0],
	[698, 2, 5, 12, 5, 3, 0, 1, 2, 1, 2],
	[699, 2, 5, 14, 5, 4, 0, 0, 3, 1, 1],
	[700, 2, 7, 16, 7, 4, 1, 0, 2, 1, 2],
	[701, 2, 4, 21, 4, 3, 2, 0, 6, 0, 2],
	[702, 1, 6, 25, 6, 4, 1, 1, 7, 1, 2],
	[703, 1, 6, 22, 6, 4, 0, 0, 7, 2, 1],
	[704, 1, 6, 16, 6, 3, 1, 0, 2, 2, 0],
	[705, 2, 3, 18, 3, 2, 2, 1, 5, 2, 2],
	[706, 2, 4, 18, 4, 2, 2, 1, 5, 1, 1],
	[707, 1, 6, 16, 6, 3, 0, 0, 4, 1, 0],
	[708, 3, 4, 17, 4, 2, 0, 1, 5, 1, 0],
	[709, 1, 3, 9, 3, 2, 2, 1, 0, 1, 1],
	[710, 1, 6, 16, 6, 3, 1, 0, 5, 2, 2],
	[711, 1, 8, 14, 8, 4, 0, 1, 3, 0, 2],
	[712, 1, 6, 9, 6, 3, 2, 0, 0, 0, 0],
	[713, 2, 3, 15, 3, 1, 2, 1, 3, 2, 1],
	[714, 2, 5, 18, 5, 2, 1, 0, 3, 1, 0],
	[715, 3, 4, 20, 4, 3, 1, 0, 7, 0, 1],
	[716, 1, 6, 18, 6, 4, 1, 0, 3, 0, 0],
	[717, 2, 5, 19, 5, 3, 0, 0, 6, 1, 0],
	[718, 1, 6, 11, 6, 4, 2, 0, 1, 1, 0],
	[719, 1, 4, 19, 4, 2, 1, 0, 6, 1, 0],
	[720, 2, 8, 16, 8, 4, 2, 1, 3, 0, 0],
	[721, 1, 3, 9, 3, 0, 1, 0, 1, 0, 2],
	[722, 3, 4, 18, 4, 2, 2, 0, 5, 2, 0],
	[723, 1, 6, 9, 6, 4, 2, 0, 0, 2, 0],
	[724, 1, 1, 10, 1, 0, 0, 1, 1, 1, 1],
	[725, 1, 3, 9, 3, 1, 2, 0, 0, 1, 0],
	[726, 2, 6, 11, 6, 4, 1, 0, 2, 0, 1],
	[727, 2, 3, 14, 3, 0, 0, 0, 3, 1, 1],
	[728, 1, 7, 13, 7, 4, 1, 0, 3, 1, 1],
	[729, 2, 4, 24, 4, 0, 1, 1, 6, 1, 2],
	[730, 3, 4, 18, 4, 3, 2, 1, 5, 2, 1],
	[731, 1, 4, 12, 4, 0, 0, 1, 2, 1, 1],
	[732, 3, 5, 22, 5, 4, 0, 0, 7, 0, 0],
	[733, 3, 3, 20, 3, 3, 1, 0, 7, 1, 2],
	[734, 1, 3, 9, 3, 0, 1, 0, 1, 0, 1],
	[735, 1, 2, 12, 2, 0, 0, 1, 2, 1, 2],
	[736, 2, 5, 14, 5, 3, 2, 1, 2, 2, 1],
	[737, 2, 4, 21, 4, 2, 0, 1, 7, 0, 0],
	[738, 0, 6, 21, 6, 4, 2, 1, 6, 1, 2],
	[739, 2, 3, 11, 3, 1, 2, 1, 1, 1, 1],
	[740, 1, 3, 8, 3, 0, 0, 0, 0, 2, 1],
	[741, 2, 3, 17, 3, 0, 0, 1, 5, 0, 1],
	[742, 3, 6, 17, 6, 4, 1, 1, 5, 2, 1],
	[743, 2, 4, 19, 4, 2, 1, 1, 6, 2, 2],
	[744, 0, 4, 17, 4, 1, 2, 0, 4, 2, 0],
	[745, 1, 2, 13, 2, 0, 1, 1, 3, 2, 2],
	[746, 1, 5, 7, 5, 3, 1, 0, 0, 1, 2],
	[747, 1, 4, 14, 4, 3, 0, 0, 3, 2, 2],
	[748, 4, 4, 20, 4, 0, 2, 1, 5, 1, 1],
	[749, 1, 3, 20, 3, 0, 1, 1, 7, 2, 2],
	[750, 1, 7, 14, 7, 4, 2, 0, 2, 2, 2],
	[751, 1, 3, 10, 3, 1, 0, 0, 1, 1, 1],
	[752, 2, 3, 11, 3, 1, 2, 0, 1, 1, 0],
	[753, 2, 2, 19, 2, 0, 1, 1, 6, 0, 1],
	[754, 2, 4, 20, 4, 2, 0, 0, 6, 2, 0],
	[755, 2, 5, 14, 5, 3, 2, 1, 2, 2, 2],
	[756, 1, 7, 8, 7, 4, 0, 1, 0, 2, 1],
	[757, 2, 4, 15, 4, 2, 0, 1, 4, 1, 2],
	[758, 2, 3, 15, 3, 1, 0, 1, 4, 2, 2],
	[759, 2, 4, 18, 4, 0, 1, 0, 3, 0, 2],
	[760, 1, 3, 17, 3, 0, 1, 0, 5, 1, 2],
	[761, 2, 3, 21, 3, 1, 0, 0, 7, 0, 2],
	[762, 2, 4, 22, 4, 1, 2, 0, 6, 2, 0],
	[763, 1, 4, 17, 4, 1, 2, 1, 4, 1, 2],
	[764, 1, 3, 9, 3, 3, 2, 0, 0, 1, 2],
	[765, 2, 7, 17, 7, 4, 2, 0, 4, 2, 2],
	[766, 1, 4, 15, 4, 3, 2, 1, 3, 1, 1],
	[767, 0, 7, 21, 7, 4, 0, 1, 7, 1, 0],
	[768, 1, 7, 21, 7, 4, 2, 1, 6, 1, 0],
	[769, 2, 7, 18, 7, 4, 2, 1, 5, 1, 0],
	[770, 1, 3, 9, 3, 1, 2, 1, 0, 2, 0],
	[771, 1, 4, 13, 4, 2, 2, 1, 2, 0, 2],
	[772, 3, 6, 22, 6, 3, 1, 0, 5, 0, 1],
	[773, 3, 2, 17, 2, 0, 0, 1, 5, 1, 0],
	[774, 3, 7, 22, 7, 4, 2, 1, 7, 2, 1],
	[775, 4, 3, 20, 3, 0, 0, 1, 6, 2, 0],
	[776, 2, 5, 20, 5, 3, 0, 1, 6, 0, 1],
	[777, 1, 3, 16, 3, 1, 0, 0, 4, 1, 2],
	[778, 1, 4, 24, 4, 2, 2, 1, 7, 2, 2],
	[779, 2, 3, 20, 3, 0, 0, 0, 6, 0, 2],
	[780, 1, 3, 19, 3, 1, 1, 0, 6, 2, 1],
	[781, 3, 3, 16, 3, 0, 1, 1, 5, 1, 0],
	[782, 2, 5, 10, 5, 3, 0, 0, 1, 1, 0],
	[783, 3, 4, 26, 4, 1, 1, 1, 7, 1, 0],
	[784, 2, 6, 19, 6, 3, 1, 1, 4, 0, 1],
	[785, 1, 8, 22, 8, 4, 2, 1, 6, 0, 0],
	[786, 2, 3, 13, 3, 0, 2, 0, 2, 0, 0],
	[787, 1, 5, 9, 5, 3, 1, 0, 1, 0, 0],
	[788, 2, 5, 16, 5, 3, 1, 0, 5, 0, 2],
	[789, 3, 4, 21, 4, 0, 1, 0, 7, 0, 0],
	[790, 2, 7, 21, 7, 4, 2, 1, 6, 2, 1],
	[791, 1, 4, 7, 4, 2, 1, 0, 0, 1, 1],
	[792, 1, 6, 21, 6, 4, 0, 0, 7, 2, 1],
	[793, 2, 4, 11, 4, 2, 2, 0, 1, 2, 1],
	[794, 2, 4, 20, 4, 1, 1, 1, 4, 0, 0],
	[795, 2, 4, 14, 4, 0, 2, 0, 2, 1, 2],
	[796, 0, 4, 19, 4, 1, 1, 1, 4, 2, 2],
	[797, 1, 3, 22, 3, 0, 0, 0, 7, 1, 1],
	[798, 2, 3, 11, 3, 2, 2, 0, 1, 2, 1],
	[799, 3, 3, 17, 3, 0, 0, 0, 5, 2, 0],
	[800, 1, 4, 11, 4, 2, 2, 0, 1, 0, 2],
	[801, 1, 7, 7, 7, 4, 1, 0, 0, 1, 2],
	[802, 3, 4, 21, 4, 2, 2, 0, 6, 2, 1],
	[803, 2, 5, 15, 5, 4, 1, 1, 4, 1, 1],
	[804, 1, 3, 9, 3, 0, 2, 0, 0, 1, 0],
	[805, 2, 3, 18, 3, 3, 2, 1, 5, 2, 1],
	[806, 2, 3, 12, 3, 0, 0, 1, 2, 1, 1],
	[807, 3, 4, 24, 4, 1, 2, 1, 7, 1, 0],
	[808, 2, 6, 18, 6, 3, 2, 1, 5, 0, 0],
	[809, 2, 8, 17, 8, 4, 2, 0, 4, 1, 2],
	[810, 4, 8, 21, 8, 4, 2, 1, 6, 1, 2],
	[811, 1, 5, 11, 5, 3, 1, 0, 2, 1, 2],
	[812, 2, 6, 12, 6, 4, 0, 0, 2, 1, 0],
	[813, 1, 6, 23, 6, 3, 2, 1, 7, 1, 0],
	[814, 3, 4, 26, 4, 1, 1, 1, 7, 1, 1],
	[815, 2, 6, 16, 6, 4, 2, 1, 3, 2, 2],
	[816, 3, 4, 23, 4, 2, 2, 0, 7, 2, 2],
	[817, 2, 8, 19, 8, 4, 1, 1, 4, 1, 1],
	[818, 2, 3, 15, 3, 3, 0, 0, 4, 0, 2],
	[819, 2, 4, 18, 4, 2, 1, 1, 3, 0, 2],
	[820, 1, 3, 18, 3, 0, 0, 1, 5, 1, 1],
	[821, 4, 3, 22, 3, 0, 0, 0, 7, 0, 0],
	[822, 3, 5, 19, 5, 3, 2, 1, 5, 0, 2],
	[823, 2, 4, 13, 4, 1, 2, 1, 2, 2, 0],
	[824, 2, 4, 18, 4, 2, 1, 1, 3, 1, 1],
	[825, 1, 8, 8, 8, 4, 0, 0, 0, 2, 1],
	[826, 2, 4, 25, 4, 1, 1, 0, 7, 1, 2],
	[827, 4, 4, 26, 4, 1, 1, 1, 7, 2, 2],
	[828, 1, 5, 8, 5, 3, 1, 0, 1, 2, 1],
	[829, 2, 8, 14, 8, 4, 0, 0, 3, 0, 1],
	[830, 2, 5, 12, 5, 3, 0, 1, 2, 0, 1],
	[831, 2, 3, 20, 3, 0, 0, 0, 6, 1, 1],
	[832, 1, 5, 21, 5, 3, 0, 0, 7, 0, 0],
	[833, 3, 4, 23, 4, 1, 2, 0, 7, 1, 0],
	[834, 3, 6, 18, 6, 4, 2, 1, 5, 0, 0],
	[835, 2, 4, 13, 4, 0, 2, 1, 2, 2, 1],
	[836, 3, 3, 17, 3, 0, 2, 0, 4, 1, 1],
	[837, 1, 5, 15, 5, 3, 2, 0, 3, 0, 0],
	[838, 2, 2, 15, 2, 0, 0, 1, 4, 1, 1],
	[839, 1, 3, 14, 3, 2, 1, 1, 4, 0, 0],
	[840, 1, 8, 9, 8, 4, 2, 1, 0, 0, 1],
	[841, 1, 3, 16, 3, 0, 1, 0, 5, 1, 0],
	[842, 0, 4, 22, 4, 0, 2, 1, 7, 0, 0],
	[843, 1, 3, 14, 3, 2, 0, 1, 3, 1, 0],
	[844, 2, 3, 13, 3, 1, 2, 0, 2, 2, 0],
	[845, 1, 6, 13, 6, 4, 1, 1, 3, 0, 0],
	[846, 3, 3, 21, 3, 0, 0, 1, 7, 1, 1],
	[847, 1, 2, 8, 2, 0, 0, 1, 0, 1, 1],
	[848, 1, 3, 9, 3, 1, 0, 0, 1, 2, 2],
	[849, 1, 5, 17, 5, 4, 0, 1, 5, 1, 1],
	[850, 2, 8, 18, 8, 4, 1, 0, 3, 1, 2],
	[851, 1, 5, 17, 5, 4, 0, 1, 5, 2, 2],
	[852, 3, 2, 16, 2, 0, 1, 1, 5, 2, 2],
	[853, 3, 3, 16, 3, 1, 1, 0, 5, 2, 1],
	[854, 1, 3, 9, 3, 2, 2, 0, 0, 0, 0],
	[855, 2, 3, 10, 3, 1, 0, 1, 1, 1, 2],
	[856, 1, 5, 22, 5, 1, 0, 1, 7, 2, 2],
	[857, 1, 4, 9, 4, 2, 1, 0, 1, 0, 1],
	[858, 2, 7, 24, 7, 4, 1, 1, 6, 0, 2],
	[859, 1, 3, 9, 3, 0, 2, 0, 0, 0, 2],
	[860, 0, 7, 15, 7, 4, 0, 0, 4, 0, 0],
	[861, 3, 4, 21, 4, 2, 1, 0, 5, 1, 2],
	[862, 1, 4, 22, 4, 0, 2, 1, 6, 0, 0],
	[863, 1, 3, 8, 3, 1, 0, 0, 0, 2, 2],
	[864, 0, 6, 17, 6, 3, 2, 1, 4, 2, 1],
	[865, 1, 5, 14, 5, 3, 0, 0, 3, 2, 1],
	[866, 3, 5, 23, 5, 2, 1, 0, 6, 1, 2],
	[867, 2, 3, 20, 3, 0, 0, 0, 6, 0, 0],
	[868, 2, 7, 16, 7, 4, 1, 1, 2, 2, 0],
	[869, 4, 4, 26, 4, 2, 1, 1, 7, 0, 2],
	[870, 1, 7, 9, 7, 4, 0, 0, 1, 2, 0],
	[871, 2, 3, 12, 3, 2, 0, 1, 2, 2, 0],
	[872, 1, 4, 21, 4, 0, 1, 1, 5, 0, 2],
	[873, 1, 7, 9, 7, 4, 1, 0, 1, 1, 1],
	[874, 3, 7, 20, 7, 4, 1, 0, 4, 0, 0],
	[875, 2, 3, 22, 3, 2, 0, 1, 7, 0, 1],
	[876, 1, 3, 13, 3, 0, 1, 0, 3, 2, 1],
	[877, 1, 3, 9, 3, 1, 2, 0, 0, 2, 1],
	[878, 1, 4, 21, 4, 2, 2, 1, 6, 2, 2],
	[879, 2, 7, 17, 7, 4, 2, 0, 4, 0, 2],
	[880, 1, 4, 20, 4, 2, 0, 1, 7, 0, 1],
	[881, 1, 4, 18, 4, 3, 0, 1, 5, 0, 0],
	[882, 2, 3, 16, 3, 0, 2, 0, 4, 1, 0],
	[883, 1, 4, 16, 4, 2, 0, 0, 4, 0, 0],
	[884, 2, 8, 14, 8, 4, 2, 0, 2, 1, 0],
	[885, 2, 3, 21, 3, 1, 0, 1, 7, 0, 0],
	[886, 2, 4, 23, 4, 3, 2, 1, 7, 0, 1],
	[887, 2, 4, 18, 4, 3, 2, 1, 5, 0, 2],
	[888, 0, 4, 21, 4, 2, 2, 1, 6, 1, 1],
	[889, 1, 6, 16, 6, 3, 1, 1, 2, 0, 1],
	[890, 1, 5, 7, 5, 2, 1, 1, 0, 2, 0],
	[891, 1, 4, 16, 4, 3, 2, 1, 3, 2, 0],
	[892, 1, 5, 8, 5, 2, 1, 1, 1, 2, 1],
	[893, 1, 3, 14, 3, 1, 1, 0, 4, 2, 1],
	[894, 1, 8, 11, 8, 4, 2, 0, 1, 0, 0],
	[895, 1, 3, 7, 3, 2, 1, 1, 0, 1, 1],
	[896, 3, 5, 21, 5, 3, 2, 0, 6, 2, 2],
	[897, 2, 4, 22, 4, 1, 2, 0, 6, 1, 2],
	[898, 2, 2, 10, 2, 1, 0, 1, 1, 1, 1],
	[899, 2, 4, 13, 4, 0, 2, 1, 2, 2, 0],
	[900, 2, 7, 20, 7, 4, 1, 0, 7, 0, 2],
	[901, 3, 5, 21, 5, 3, 0, 1, 7, 2, 2],
	[902, 2, 4, 11, 4, 0, 1, 1, 2, 1, 2],
	[903, 2, 5, 18, 5, 3, 1, 0, 6, 0, 1],
	[904, 0, 6, 15, 6, 4, 0, 0, 4, 0, 2],
	[905, 1, 8, 24, 8, 4, 1, 0, 6, 0, 1],
	[906, 1, 6, 18, 6, 4, 2, 1, 5, 1, 0],
	[907, 1, 4, 9, 4, 2, 2, 1, 0, 1, 2],
	[908, 1, 5, 20, 5, 2, 2, 1, 6, 0, 2],
	[909, 2, 4, 15, 4, 2, 0, 1, 4, 0, 2],
	[910, 2, 5, 17, 5, 2, 0, 1, 5, 2, 0],
	[911, 3, 3, 17, 3, 1, 0, 1, 5, 1, 2],
	[912, 1, 6, 21, 6, 4, 1, 1, 5, 2, 0],
	[913, 2, 4, 11, 4, 2, 1, 0, 2, 0, 2],
	[914, 3, 4, 16, 4, 1, 2, 1, 3, 2, 0],
	[915, 2, 4, 16, 4, 2, 2, 1, 3, 0, 1],
	[916, 0, 3, 16, 3, 2, 0, 0, 4, 2, 1],
	[917, 1, 2, 12, 2, 0, 0, 1, 2, 1, 1],
	[918, 2, 4, 22, 4, 3, 2, 1, 6, 1, 2],
	[919, 1, 5, 7, 5, 3, 1, 0, 0, 0, 1],
	[920, 2, 6, 17, 6, 3, 0, 0, 5, 1, 0],
	[921, 1, 4, 14, 4, 2, 1, 0, 4, 0, 0],
	[922, 2, 5, 11, 5, 2, 2, 0, 1, 2, 2],
	[923, 1, 3, 9, 3, 0, 1, 0, 1, 0, 1],
	[924, 2, 4, 17, 4, 0, 2, 1, 4, 2, 2],
	[925, 1, 5, 18, 5, 3, 2, 1, 5, 1, 0],
	[926, 2, 8, 18, 8, 4, 1, 1, 3, 2, 1],
	[927, 2, 3, 11, 3, 3, 2, 1, 1, 2, 2],
	[928, 1, 4, 20, 4, 0, 0, 1, 7, 1, 1],
	[929, 0, 3, 19, 3, 0, 0, 1, 6, 0, 2],
	[930, 1, 3, 16, 3, 2, 0, 0, 4, 2, 0],
	[931, 1, 2, 7, 2, 0, 1, 1, 0, 1, 2],
	[932, 1, 7, 12, 7, 4, 0, 1, 2, 2, 1],
	[933, 2, 4, 19, 4, 1, 2, 1, 5, 1, 2],
	[934, 2, 3, 13, 3, 0, 2, 0, 2, 1, 0],
	[935, 1, 3, 9, 3, 2, 2, 0, 0, 1, 2],
	[936, 3, 3, 17, 3, 0, 1, 0, 5, 1, 1],
	[937, 1, 3, 11, 3, 1, 2, 0, 1, 2, 0],
	[938, 1, 4, 17, 4, 3, 2, 1, 4, 0, 0],
	[939, 0, 3, 17, 3, 0, 2, 1, 4, 2, 2],
	[940, 2, 3, 15, 3, 1, 0, 1, 4, 1, 2],
	[941, 3, 7, 16, 7, 4, 0, 1, 4, 1, 1],
	[942, 2, 4, 14, 4, 2, 2, 0, 2, 2, 2],
	[943, 3, 5, 19, 5, 3, 2, 1, 5, 0, 1],
	[944, 1, 6, 16, 6, 4, 0, 1, 4, 0, 0],
	[945, 2, 3, 16, 3, 2, 1, 1, 5, 2, 0],
	[946, 0, 6, 15, 6, 4, 0, 1, 4, 1, 2],
	[947, 3, 4, 20, 4, 2, 0, 0, 7, 2, 2],
	[948, 1, 5, 11, 5, 3, 1, 1, 2, 0, 0],
	[949, 0, 3, 14, 3, 1, 1, 1, 4, 2, 2],
	[950, 2, 5, 16, 5, 3, 2, 0, 4, 0, 1],
	[951, 1, 4, 11, 4, 0, 1, 0, 2, 1, 2],
	[952, 1, 7, 17, 7, 4, 1, 1, 5, 1, 1],
	[953, 1, 5, 12, 5, 3, 0, 1, 2, 1, 1],
	[954, 3, 3, 19, 3, 1, 2, 1, 5, 1, 1],
	[955, 2, 6, 18, 6, 4, 1, 1, 3, 2, 1],
	[956, 1, 7, 14, 7, 4, 0, 0, 3, 1, 2],
	[957, 3, 4, 18, 4, 1, 1, 0, 3, 1, 0],
	[958, 2, 3, 10, 3, 1, 0, 1, 1, 0, 2],
	[959, 4, 4, 24, 4, 2, 2, 1, 7, 1, 0],
	[960, 1, 4, 18, 4, 1, 2, 0, 4, 2, 1],
	[961, 2, 6, 13, 6, 4, 1, 1, 3, 2, 1],
	[962, 1, 3, 10, 3, 1, 2, 0, 1, 1, 2],
	[963, 3, 4, 22, 4, 1, 2, 0, 7, 1, 1],
	[964, 1, 6, 7, 6, 3, 1, 0, 0, 2, 1],
	[965, 3, 2, 19, 2, 0, 1, 1, 6, 0, 1],
	[966, 1, 8, 8, 8, 4, 0, 1, 0, 2, 1],
	[967, 2, 6, 21, 6, 4, 1, 0, 5, 2, 2],
	[968, 2, 4, 14, 4, 1, 2, 0, 2, 1, 2],
	[969, 1, 3, 15, 3, 1, 2, 1, 3, 0, 2],
	[970, 2, 7, 11, 7, 4, 2, 1, 1, 1, 0],
	[971, 1, 8, 22, 8, 4, 0, 1, 7, 2, 2],
	[972, 1, 4, 11, 4, 3, 1, 0, 2, 1, 0],
	[973, 2, 4, 13, 4, 2, 1, 0, 3, 0, 1],
	[974, 3, 8, 19, 8, 4, 0, 1, 6, 0, 2],
	[975, 2, 8, 19, 8, 4, 1, 1, 7, 1, 1],
	[976, 2, 6, 13, 6, 4, 1, 0, 3, 2, 0],
	[977, 2, 4, 17, 4, 2, 2, 0, 4, 2, 0],
	[978, 1, 3, 9, 3, 2, 2, 0, 0, 1, 1],
	[979, 1, 5, 11, 5, 3, 2, 0, 1, 1, 0],
	[980, 1, 6, 23, 6, 3, 2, 1, 7, 1, 0],
	[981, 2, 3, 15, 3, 1, 2, 0, 3, 2, 1],
	[982, 0, 4, 17, 4, 1, 2, 1, 4, 0, 1],
	[983, 0, 5, 16, 5, 2, 0, 1, 4, 0, 2],
	[984, 0, 6, 18, 6, 3, 1, 0, 6, 1, 1],
	[985, 1, 3, 17, 3, 3, 0, 1, 5, 2, 0],
	[986, 2, 3, 15, 3, 2, 0, 0, 4, 1, 2],
	[987, 3, 4, 20, 4, 0, 2, 1, 5, 0, 1],
	[988, 1, 7, 9, 7, 4, 2, 0, 0, 1, 1],
	[989, 1, 4, 14, 4, 0, 2, 0, 2, 2, 1],
	[990, 1, 6, 13, 6, 3, 2, 0, 2, 1, 0],
	[991, 1, 3, 9, 3, 0, 2, 1, 0, 0, 1],
	[992, 2, 3, 17, 3, 1, 2, 1, 4, 2, 1],
	[993, 3, 4, 15, 4, 3, 2, 1, 3, 2, 1],
	[994, 1, 8, 16, 8, 4, 1, 1, 2, 0, 1],
	[995, 3, 3, 20, 3, 1, 1, 1, 7, 2, 2],
	[996, 2, 6, 15, 6, 4, 2, 0, 3, 1, 0],
	[997, 1, 3, 15, 3, 0, 0, 1, 4, 0, 2],
	[998, 1, 7, 18, 7, 4, 2, 1, 5, 2, 2],
	[999, 2, 5, 14, 5, 4, 1, 0, 4, 1, 1],
	// 1000 exists but only as a prebuilt wand
];

export const WAND_TIERS = [
	'P', '1', '1NS',
	'2', '2NS', '2B',
	'3', '3NS', '3B',
	'4', '4NS', '4B',
	'5', '5NS', '5B',
	'6', '6NS', '6B',
	'10', '10NS',
];

export function getWandTierIndex(w) {
	if (typeof w.level !== 'number') return WAND_TIERS.indexOf('P');
	const level = w.level > 10 ? 10 : w.level;
	if (w.original_force_unshuffle === 1) return WAND_TIERS.indexOf(`${level}N`);
	if (w.wand_type === 'better') return WAND_TIERS.indexOf(`${level}B`);
	return WAND_TIERS.indexOf(`${level}`);
}